import { useNavigate } from 'react-router';
import { FormattedMessage } from 'react-intl';

import { Box, Button, Grid, Typography } from '@mui/material';

import { APP_DEFAULT_PATH } from 'constants/appConstants';

import { boldChunk } from 'utils/intlChunkUtils';

const values = {
  email: 'hello@trendiolive.com',
  ...boldChunk
};
export default function ErrorPage() {
  const navigate = useNavigate();
  return (
    <Grid
      container
      spacing={10}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh', pt: 1.5, pb: 1, overflow: 'hidden' }}
    >
      <Grid size={{ xs: 12 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
          <Typography variant="h1">
            <FormattedMessage id="something-went-wrong" />
          </Typography>
          <Typography color="textSecondary" align="center" sx={{ width: { xs: '73%', sm: '61%' } }}>
            <FormattedMessage id="unexpected-error-occurred-sorry" />
          </Typography>
          <Typography color="textSecondary" align="center" sx={{ width: { xs: '73%', sm: '61%' } }}>
            <FormattedMessage id="please-refresh-or-contact-email" values={values} />
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Button variant="contained" color="primary" onClick={() => navigate(APP_DEFAULT_PATH)}>
              <FormattedMessage id="go-to-home" />
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
